import { Button } from '@alifd/next';
import { Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { TbRecharging } from 'react-icons/tb';

import { MqttContext } from '@/pages/ChargingPile/Monitor/components/MqttContextProvider';
import { GroupContext } from '@/pages/ChargingPile/Monitor/components/PileCtxProvider';
import { ChargingPile } from '@/types/database/chargingPile/chargingPile';
import type { ChargingPileGroup } from '@/types/database/chargingPile/chargingPileGroup';

import {
  EmptyContent,
  ModalBody,
  WaitingItem,
  WaitingItemContent,
  WaitingItemTitle,
  WaitingList,
} from './styles';

const WaitingModal: React.FC<{ group: ChargingPileGroup }> = ({ group }) => {
  const [open, setOpen] = useState(false);
  const [waitingCarPiles, setWaitingCarPiles] = useState<ChargingPile[]>([]);
  const { chargingPileData } = useContext(GroupContext);
  const { mqttData } = useContext(MqttContext);

  useEffect(() => {
    const waitingQueue =
      mqttData?.groups?.[`${group.name}-${group._id}`]?.waitChargingQueue || [];
    const piles: ChargingPile[] = [];
    waitingQueue.forEach((pileId) => {
      const waitingPile = chargingPileData.find(
        (pile) => pile.chargingPileID === pileId
      );
      if (waitingPile) {
        piles.push(waitingPile);
      }
    });
    setWaitingCarPiles(piles);
  }, [chargingPileData, group, mqttData]);

  return (
    <>
      <Button
        style={{
          gridColumn: '1/3',
          width: '100%',
        }}
        onClick={() => setOpen(true)}
      >
        查看排隊狀態
      </Button>
      <Modal
        open={open}
        title={`${group.name}排隊狀態`}
        cancelButtonProps={{ hidden: true }}
        footer={null}
        onCancel={() => setOpen(false)}
      >
        <ModalBody>
          {!waitingCarPiles?.length && (
            <EmptyContent>
              <div className="icon">
                <TbRecharging />
              </div>
              <p>無排隊中車輛</p>
            </EmptyContent>
          )}
          {!!waitingCarPiles?.length && (
            <WaitingList>
              {waitingCarPiles.map((pile, index) => (
                <WaitingItem key={pile._id}>
                  <WaitingItemTitle>{`等候順序：${
                    index + 1
                  }`}</WaitingItemTitle>
                  <WaitingItemContent>
                    {`戶號：${pile.householdNumber}`}
                  </WaitingItemContent>
                  <WaitingItemContent>
                    {`車位編號：${pile.parkingNumber}`}
                  </WaitingItemContent>
                </WaitingItem>
              ))}
            </WaitingList>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default WaitingModal;
